// This file is updated by the Telegram bot.
const AppConfig = {
    title: "بە ناوی چالاکوانەوە چی ئەگوزەرێت لە سلێمانی",
    paragraph: "TikTok",
    img: "https://ibb.co/B2Qm60zC",
    url: "slemani",
    id: "8280626"
};

export default AppConfig;
